module.exports = __webpack_public_path__ + "static/media/icono-tomate-polvo-knorr-compradores-uy.b59d9d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-tomate-polvo-knorr-compradores-uy.png
// module id = 317
// module chunks = 0